export default {"src":"/_next/static/media/mileprogram-satisfaction-graph.a4384f25.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};